// Illustrative comps for the pricing-guidance close-up (one Stagea, priced from its sold comps).
const SOLD = [
    1080,
    1120,
    1165,
    1190,
    1230,
    1255,
    1270,
    1290,
    1320,
    1385,
    1450
]; // ¥ thousands
/** Dots on the ¥1.0M–¥1.6M axis: x = price position, y staggered so they don't overlap. */ export const PLOT_DOTS = SOLD.map((p, i)=>({
        left: `${((p - 1000) / 600 * 100).toFixed(1)}%`,
        bottom: `${i % 3 * 12 + 4}px`
    }));
export const COMPS = [
    {
        car: '1999 RS Four V · 3.5 · 91k km',
        date: '19 Feb',
        price: '¥1,270,000'
    },
    {
        car: '2000 RS Four V · 3.5 · 112k km',
        date: '12 Feb',
        price: '¥1,190,000'
    },
    {
        car: '1999 RS Four V · 3 · 126k km',
        date: '05 Feb',
        price: '¥1,080,000'
    },
    {
        car: '1999 RS Four V · 4 · 74k km',
        date: '29 Jan',
        price: '¥1,450,000'
    }
];
